import React from 'react';
import { motion } from 'framer-motion';
import { Lock } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
export function OfferSection() {
  return <section id="offer-cta" className="px-6 py-10" data-id="element-117">
      <div className="max-w-3xl mx-auto text-center" data-id="element-118">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-gradient-to-b from-brand-light/5 to-transparent border border-brand-light/10 rounded-3xl p-8 md:p-16" data-id="element-119">
          <h3 className="font-serif text-3xl md:text-4xl text-brand-light mb-6" data-id="element-120">
            Recupera el puente hacia tu pareja por menos de lo que cuesta una
            pizza familiar.
          </h3>

          <p className="text-xl text-brand-light/80 mb-6 font-light" data-id="element-121">
            Consigue la Guía "Más Que Padres" hoy por solo{' '}
            <span className="text-3xl font-serif text-brand-accent font-bold ml-2" data-id="element-122">
              $6.39
            </span>
          </p>

          <motion.a href="https://www.nachogerberg.com/cart/42741549432903:1" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} whileHover={{
          scale: 1.02,
          filter: 'brightness(1.1)'
        }} whileTap={{
          scale: 0.98
        }} className="inline-block w-full md:w-auto bg-brand-accent text-brand-light px-8 py-5 rounded-full font-medium text-lg md:text-xl shadow-lg shadow-brand-accent/20 transition-all text-center" data-id="element-123">
            QUIERO RECUPERAR MI PAREJA AHORA
          </motion.a>

          <p className="mt-8 text-brand-light/50 text-sm font-light" data-id="element-124">
            <Lock className="w-3.5 h-3.5 inline-block align-middle mr-1" data-id="element-125" />
            <span className="align-middle" data-id="element-126">
              Acceso instantáneo tras la compra. Pago seguro y discreto.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}